module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	
	fox.registerWidget('User_FavoriteAmc', {
		redrawFavorites: function(data)
		{
			this.isFavorite = data.response.success.isFavorite;

			if (this.isFavorite == 1) {
				fox.dom.selectFirst(this.options.showTarget, this.element).classList.add(this.options.showActive);
			} else {
				fox.dom.selectFirst(this.options.showTarget, this.element).classList.remove(this.options.showActive);
			}
		}
		
	}, 'User_Favorite');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/widget/user/favoriteamc.js
// module id = 159
// module chunks = 4